import { render } from "./UserModal1_sub.vue?vue&type=template&id=2622c9d1"
import script from "./UserModal1_sub.vue?vue&type=script&lang=ts"
export * from "./UserModal1_sub.vue?vue&type=script&lang=ts"

import "./UserModal1_sub.vue?vue&type=style&index=0&id=2622c9d1&lang=css"
script.render = render

export default script